import React from "react";
import { NavLink } from "react-router-dom";
import { useInView } from "react-intersection-observer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import styled from "styled-components";

function About() {
  const [ref, inView] = useInView({
    threshold: 0.3,
    triggerOnce: true,
  });

  return (
    <ScAbout ref={ref}>
      <article className="aboutContent">
        {inView && <h2 className="aboutTitle">| Your Vision, Our Passion</h2>}
        {inView && (
          <div className="aboutText">
            <p>We are a team of Strategists, Designers, and Developers.</p>
            <p>With all this, we create dynamic websites, brands, and</p>
            <p>user experiences that are clean, modern, and reflect</p>
            <p>your vision.</p>
          </div>
        )}
        {inView && (
          <div className="aboutText aboutTextSm">
            <p>We are a team of Strategists, Designers,</p>
            <p>and Developers. With all this, we create</p>
            <p>dynamic websites, brands, and user </p>
            <p>
              experiences that are clean, modern, <br /> and reflect your
              vision.
            </p>
          </div>
        )}
      </article>
      <button className="aboutBtn" tabIndex={-1}>
        <NavLink to="/About" tabIndex={7}>
          Meet The Team
        </NavLink>
        <FontAwesomeIcon icon={faChevronRight} className="faIcon" />
      </button>
    </ScAbout>
  );
}

const ScAbout = styled("section")`
  background: var(--light);
  width: 100vw;
  height: 100vh;
  min-height: 42rem;

  > * {
    position: absolute;
  }

  .aboutContent {
    /* border: 1px solid red; */
    top: 46%;
    left: 6%;
    transform: translate(0, -50%);
    width: 92%;
    .aboutTitle {
      font-size: calc(1rem + 5.2vw);
      font-weight: 500;
      margin-bottom: 4vw;
      opacity: 0;
      transform: translate(0, 40%);
      animation: fadeUp 0.6s ease 0.2s forwards;
    }
    .aboutText {
      font-size: calc(0.2rem + 2.8vw);
      opacity: 0;
      transform: translate(0, 20%);
      animation: fadeUp 0.8s ease 0.3s forwards;
      p {
        position: relative;
        &::after {
          content: "";
          position: absolute;
          bottom: 0;
          right: 0;
          width: 100%;
          height: 100%;
          background: var(--light);
          animation: sliderAlt 0.8s ease forwards;
        }
        &:nth-of-type(1) {
          &::after {
            animation-delay: 0.4s;
          }
        }
        &:nth-of-type(2) {
          &::after {
            animation-delay: 0.5s;
          }
        }
        &:nth-of-type(3) {
          &::after {
            animation-delay: 0.6s;
          }
        }
        &:nth-of-type(4) {
          &::after {
            animation-delay: 0.7s;
          }
        }
      }
    }
    .aboutTextSm {
      display: none;
    }
  }

  .aboutBtn {
    position: relative;
    top: 82%;
    left: 8%;
    transform: scale(1.2);
    z-index: 2;
    a {
      color: var(--dark);
      font-size: calc(0.8rem + 0.8vw);
      font-weight: 400;
      transition: color 0.4s ease 0.2s;
    }
    .faIcon {
      position: absolute;
      top: 50%;
      right: -6%;
      transform: translate(100%, -50%);
      font-size: calc(0.6rem + 0.6vw);
      transition: transform 0.4s cubic-bezier(0.54, -0.85, 0.45, 1.67);
    }
    &::before {
      content: "";
      position: absolute;
      top: 50%;
      left: -12%;
      transform: translate(0%, -50%);
      width: 4rem;
      height: 4rem;
      border-radius: 12rem;
      background: #c3c3c3;
      z-index: -1;
      pointer-events: none;
      transition: width 0.4s cubic-bezier(0.42, -0.49, 0.64, 1.24),
        background 0.4s ease;
    }
    &:hover {
      a {
        /* color: var(--light); */
      }
      .faIcon {
        /* font-size: calc(0rem + 0vw); */
        transform: translate(250%, -50%);
        transition-delay: 0.16s;
      }
      &::before {
        width: 124%;
        /* background: var(--offDark); */
      }
    }
  }

  @media (max-width: 1440px) {
    .aboutBtn {
      transform: scale(1);
    }
  }

  @media (max-width: 768px) {
    height: 68vh;
    min-height: 26rem;
    .aboutContent {
      width: 88%;
      .aboutTitle {
        font-size: calc(1rem + 3.4vw);
      }
      .aboutText {
        font-size: calc(0.2rem + 2.6vw);
      }
    }
    .aboutBtn {
      &::before {
        width: 3.2rem;
        height: 3.2rem;
      }
    }
  }

  @media (max-width: 520px) {
    .aboutContent {
      top: 38%;
      .aboutTitle {
        margin-bottom: 10vw;
      }
      .aboutText {
        display: none;
      }
      .aboutTextSm {
        font-size: calc(0.2rem + 3.6vw);
        display: block;
        line-height: 140%;
      }
    }
    .aboutBtn {
      top: 76%;
      &::before {
        width: 2.8rem;
        height: 2.8rem;
      }
    }
  }

  @media (max-width: 480px) {
    height: 54vh;
    min-height: 24rem;
  }
`;

export default About;
